// extracted by css-extract-rspack-plugin
export default {"removableSettingSection":"l5FewvC7R2Y3fJQr","header":"CDy8QuiDXMxTBGVL","title":"LlYZypxMjDM5zK9u"};